import InquiriesList from "./InquiriesList";

export default InquiriesList;
